import React from 'react'
import dynamic from 'next/dynamic'

const MainContainer = dynamic(() => import('../components').then(mod => mod.MainContainer))
const HeroMedia = dynamic(() => import('../components').then(mod => mod.HeroMedia))
const SectionSlider = dynamic(() => import('../components').then(mod => mod.SectionSlider))

import { isObjectEmpty, formatDate } from '../utils'
import { fetchPageByGql } from '../services'
import { STATIC_PAGE_WP_IDS, CATEGORY_NEWS_SLUGS } from '../utils/siteConfig'
import getGlobalData from '../services/cacheGlobalData'
import { PAGE_GIVING_BACK } from '../services/queries/pages'

/**
 * Fixed Page - GivingBack
 */
const GivingBack = ({ pageData, latestPressNews }) => {
  const newsArray = latestPressNews?.nodes.map(item => {
    // Get description from Headline
    const contentBuilder = item?.signaturePostNewsFields?.contentBuilder
    const filteredHeadline = contentBuilder?.filter(item => {
      return item.text
    })
    const description = filteredHeadline.length > 0 ? filteredHeadline[0].text : ''

    return {
      image: {
        sourceUrl: item?.signaturePostNewsFields?.headerImage?.sourceUrl,
        altText: item?.signaturePostNewsFields?.headerImage?.altText,
      },
      heading: item?.title,
      subHeading: '&nbsp;',
      description: description,
      cta: {
        label: 'Visit Their Website',
        type: 'internal',
        url: item?.uri,
      },
    }
  })

  return (
    <MainContainer>
      {/* <HeroMedia disableCopy={true} heroHeading={'Giving Back'} headerTitleIndent='56' /> */}

      <SectionSlider
        id='news'
        className='pb-80 bg-transparent md:pb-60 hero-pt'
        heading={pageData?.dovetailPageGivingBack?.content?.title}
        subHeading={pageData?.dovetailPageGivingBack?.content?.headline}
        sliderCards={newsArray}
        imageAspectRatio='aspect-w-4 aspect-h-3 border border-primary'        
        hoverBG={false}
        isGivingBack={true}
      />
    </MainContainer>
  )
}

// export default GivingBack;
export default React.memo(GivingBack)

export async function getStaticProps({ preview = false }) {  
  const query = PAGE_GIVING_BACK
  const params = {
    pageId: STATIC_PAGE_WP_IDS?.givingBack,
    pressTerm: CATEGORY_NEWS_SLUGS.givingBack,
  }

  const data = await fetchPageByGql(query, params, preview)

  const globalData = await getGlobalData()
  const pageData = data?.pageData || {}
  const latestPressNews = data?.latestPressNews || []

  return isObjectEmpty(pageData)
    ? { notFound: true } // returns custom 404 page
    : { props: { preview, pageData, latestPressNews, globalData } }
}
